import { Controller } from "@hotwired/stimulus"

// Triggers window.print() on click
// Usage: <button data-controller="print" data-action="click->print#print">Print</button>
export default class extends Controller {
  print() {
    window.print()
  }
}
